"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = require("../colors");
var theme = {
  colors: {
    primary: _colors.FullPalette.EVERGREEN_700,
    secondary: _colors.FullPalette.EVERGREEN_600,
    tertiary: _colors.FullPalette.GREY_900,
    link: _colors.FullPalette.GREEN_700,
    dangerLink: _colors.FullPalette.POPPY_600,
    linkHover: _colors.FullPalette.EVERGREEN_700,
    dangerLinkHover: _colors.FullPalette.POPPY_700,
    formLabel: _colors.FullPalette.GREY_900,
    required: _colors.FullPalette.POPPY_600,
    error: _colors.FullPalette.POPPY_600,
    active: _colors.FullPalette.GREEN_700,
    helper: _colors.FullPalette.EVERGREEN_600,
    dangerHelper: _colors.FullPalette.POPPY_600,
    dangerChip: _colors.FullPalette.POPPY_700,
    listViewHeader: _colors.FullPalette.EVERGREEN_600,
    listViewPrimaryCell: _colors.FullPalette.EVERGREEN_700,
    listViewSecondaryCell: _colors.FullPalette.EVERGREEN_700,
    listViewSecondaryInformation: _colors.FullPalette.EVERGREEN_700,
    metadata: _colors.FullPalette.GREY_900
  },
  fonts: {
    serif: 'Untitled Serif, serif',
    sans: 'Untitled Sans, sans-serif'
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semiBold: 600
  }
};
var _default = exports["default"] = theme;